import {useContext} from 'react'

import Context from '@s-ui/react-context'
import ActCrossed from '@adv-mt/mt-svg-icons/lib/ActCrossed.js'
import AtcOutline from '@adv-mt/mt-svg-icons/lib/AtcOutline.js'
import BagHeart from '@adv-mt/mt-svg-icons/lib/BagHeart'
import Buy from '@adv-mt/mt-svg-icons/lib/Buy'
import Calculator from '@adv-mt/mt-svg-icons/lib/Calculator'
import CalendarCarCrossed from '@adv-mt/mt-svg-icons/lib/CalendarCarCrossed.js'
import CalendarCarOutline from '@adv-mt/mt-svg-icons/lib/CalendarCarOutline.js'
import CalendarCloseOutline from '@adv-mt/mt-svg-icons/lib/CalendarCloseOutline.js'
import CalendarDaysOutline from '@adv-mt/mt-svg-icons/lib/CalendarDaysOutline.js'
import CarBreakdown from '@adv-mt/mt-svg-icons/lib/CarBreakdown.js'
import CarBreakdownCrossed from '@adv-mt/mt-svg-icons/lib/CarBreakdownCrossed.js'
import CarDeliveryCarOutline from '@adv-mt/mt-svg-icons/lib/CarDeliveryCarOutline.js'
import CarExtendedWarrantyCrossed from '@adv-mt/mt-svg-icons/lib/CarExtendedWarrantyCrossed.js'
import CarExtendedWarrantyOutline from '@adv-mt/mt-svg-icons/lib/CarExtendedWarrantyOutline.js'
import CarFee from '@adv-mt/mt-svg-icons/lib/CarFee.js'
import CarFeeCrossed from '@adv-mt/mt-svg-icons/lib/CarFeeCrossed.js'
import CarMechanicCrossed from '@adv-mt/mt-svg-icons/lib/CarMechanicCrossed.js'
import CarMechanicOutline from '@adv-mt/mt-svg-icons/lib/CarMechanicOutline.js'
import CarSubstituteAlt from '@adv-mt/mt-svg-icons/lib/CarSubstituteAlt.js'
import CarSubstituteAltCrossed from '@adv-mt/mt-svg-icons/lib/CarSubstituteAltCrossed.js'
import SubstitutionCarCrossed from '@adv-mt/mt-svg-icons/lib/CarSubstituteCrossed.js'
import SubstitutionCar from '@adv-mt/mt-svg-icons/lib/CarSubstituteOutline.js'
import CarTractionCrossed from '@adv-mt/mt-svg-icons/lib/CarTractionCrossed.js'
import CarTractionOutline from '@adv-mt/mt-svg-icons/lib/CarTractionOutline.js'
import CarWheel from '@adv-mt/mt-svg-icons/lib/CarWheel.js'
import CarWheelCrossed from '@adv-mt/mt-svg-icons/lib/CarWheelCrossed.js'
import Cash from '@adv-mt/mt-svg-icons/lib/Cash'
import Certificate from '@adv-mt/mt-svg-icons/lib/Certificate'
import Customer from '@adv-mt/mt-svg-icons/lib/Customer'
import Deal from '@adv-mt/mt-svg-icons/lib/Deal'
import DeliveringCar from '@adv-mt/mt-svg-icons/lib/DeliveringCar.js'
import EarthHome from '@adv-mt/mt-svg-icons/lib/EarthHome'
import NoEntryFee from '@adv-mt/mt-svg-icons/lib/Euro2.js'
import NoEntryFeeCrossed from '@adv-mt/mt-svg-icons/lib/EuroAltCrossed.js'
import Extras from '@adv-mt/mt-svg-icons/lib/Extras'
import FileEditCrossed from '@adv-mt/mt-svg-icons/lib/FileEditCrossed.js'
import FileEditOutline from '@adv-mt/mt-svg-icons/lib/FileEditOutline.js'
import FileTaxesOutline from '@adv-mt/mt-svg-icons/lib/FileTaxesOutline.js'
import Finance from '@adv-mt/mt-svg-icons/lib/Finance'
import Garage from '@adv-mt/mt-svg-icons/lib/Garage'
import Infinite from '@adv-mt/mt-svg-icons/lib/Infinite.js'
import InfiniteCrossed from '@adv-mt/mt-svg-icons/lib/InfiniteCrossed.js'
import Online from '@adv-mt/mt-svg-icons/lib/LaptopOutline.js'
import Parking from '@adv-mt/mt-svg-icons/lib/Parking'
import Renting from '@adv-mt/mt-svg-icons/lib/Renting'
import ShieldCalendarCrossed from '@adv-mt/mt-svg-icons/lib/ShieldCalendarCrossed.js'
import ShieldCalendarOutline from '@adv-mt/mt-svg-icons/lib/ShieldCalendarOutline.js'
import ShieldUserCrossed from '@adv-mt/mt-svg-icons/lib/ShieldUserCrossed.js'
import ShieldUserOutline from '@adv-mt/mt-svg-icons/lib/ShieldUserOutline.js'
import Shop from '@adv-mt/mt-svg-icons/lib/Shop'
import ShoppingCartCrossed from '@adv-mt/mt-svg-icons/lib/ShoppingCartCrossed.js'
import ShoppingCartOutline from '@adv-mt/mt-svg-icons/lib/ShoppingCartOutline.js'
import Slider from '@adv-mt/mt-svg-icons/lib/SliderOutline.js'
import Test from '@adv-mt/mt-svg-icons/lib/Test'
import TowTruckCrossed from '@adv-mt/mt-svg-icons/lib/TowTruckCrossed.js'
import TowTruckOutline from '@adv-mt/mt-svg-icons/lib/TowTruckOutlined.js'
import UsersCrossed from '@adv-mt/mt-svg-icons/lib/UsersCrossed.js'
import UsersOutline from '@adv-mt/mt-svg-icons/lib/UsersOutline.js'
import Warranty from '@adv-mt/mt-svg-icons/lib/Warranty'

const SERVICE_STATE = {
  INCLUDED: 'included',
  NOT_INCLUDED: 'not-included'
}

export const useServiceIcon = () => {
  const {domain} = useContext(Context)
  const config = domain.get('config')

  const DEALER_SERVICES_TYPES = config.get('DEALER_SERVICES_TYPES')

  const serviceIconMapper = {
    [DEALER_SERVICES_TYPES.BAG_HEART]: {
      [SERVICE_STATE.INCLUDED]: BagHeart,
      [SERVICE_STATE.NOT_INCLUDED]: BagHeart
    },
    [DEALER_SERVICES_TYPES.BREAKDOWNS_REPAIRS]: {
      [SERVICE_STATE.INCLUDED]: CarBreakdown,
      [SERVICE_STATE.NOT_INCLUDED]: CarBreakdownCrossed
    },
    [DEALER_SERVICES_TYPES.CAR_EXTENDED_WARRANTY]: {
      [SERVICE_STATE.INCLUDED]: CarExtendedWarrantyOutline,
      [SERVICE_STATE.NOT_INCLUDED]: CarExtendedWarrantyCrossed
    },
    [DEALER_SERVICES_TYPES.CASH]: {
      [SERVICE_STATE.INCLUDED]: Cash,
      [SERVICE_STATE.NOT_INCLUDED]: Cash
    },
    [DEALER_SERVICES_TYPES.CERTIFICATION]: {
      [SERVICE_STATE.INCLUDED]: Certificate,
      [SERVICE_STATE.NOT_INCLUDED]: Certificate
    },
    [DEALER_SERVICES_TYPES.CONFIGURABLE_CONDITIONS]: {
      [SERVICE_STATE.INCLUDED]: Slider,
      [SERVICE_STATE.NOT_INCLUDED]: Slider
    },
    [DEALER_SERVICES_TYPES.DEAL]: {
      [SERVICE_STATE.INCLUDED]: Deal,
      [SERVICE_STATE.NOT_INCLUDED]: Deal
    },
    [DEALER_SERVICES_TYPES.DELIVERY]: {
      [SERVICE_STATE.INCLUDED]: DeliveringCar,
      [SERVICE_STATE.NOT_INCLUDED]: DeliveringCar
    },
    [DEALER_SERVICES_TYPES.DRIVER_CARE]: {
      [SERVICE_STATE.INCLUDED]: AtcOutline,
      [SERVICE_STATE.NOT_INCLUDED]: ActCrossed
    },
    [DEALER_SERVICES_TYPES.EARLY_CANCELLATION_INSURANCE]: {
      [SERVICE_STATE.INCLUDED]: ShieldCalendarOutline,
      [SERVICE_STATE.NOT_INCLUDED]: ShieldCalendarCrossed
    },
    [DEALER_SERVICES_TYPES.EARTH_HOME]: {
      [SERVICE_STATE.INCLUDED]: EarthHome,
      [SERVICE_STATE.NOT_INCLUDED]: EarthHome
    },
    [DEALER_SERVICES_TYPES.EXHIBITION]: {
      [SERVICE_STATE.INCLUDED]: Shop,
      [SERVICE_STATE.NOT_INCLUDED]: Shop
    },
    [DEALER_SERVICES_TYPES.FINANCING]: {
      [SERVICE_STATE.INCLUDED]: Finance,
      [SERVICE_STATE.NOT_INCLUDED]: Finance
    },
    [DEALER_SERVICES_TYPES.FINES_MANAGEMENT]: {
      [SERVICE_STATE.INCLUDED]: CarFee,
      [SERVICE_STATE.NOT_INCLUDED]: CarFeeCrossed
    },
    [DEALER_SERVICES_TYPES.FLEXIBLE_CANCELLATION]: {
      [SERVICE_STATE.INCLUDED]: FileEditOutline,
      [SERVICE_STATE.NOT_INCLUDED]: FileEditCrossed
    },
    [DEALER_SERVICES_TYPES.FULL_COMPREHENSIVE_INSURANCE]: {
      [SERVICE_STATE.INCLUDED]: CarExtendedWarrantyOutline,
      [SERVICE_STATE.NOT_INCLUDED]: CarExtendedWarrantyOutline
    },
    [DEALER_SERVICES_TYPES.GARAGE]: {
      [SERVICE_STATE.INCLUDED]: Garage,
      [SERVICE_STATE.NOT_INCLUDED]: Garage
    },
    [DEALER_SERVICES_TYPES.HOME_DELIVERY]: {
      [SERVICE_STATE.INCLUDED]: CarDeliveryCarOutline,
      [SERVICE_STATE.NOT_INCLUDED]: CarDeliveryCarOutline
    },
    [DEALER_SERVICES_TYPES.INSPECTION_REGISTRATION_TAXES]: {
      [SERVICE_STATE.INCLUDED]: FileTaxesOutline,
      [SERVICE_STATE.NOT_INCLUDED]: FileTaxesOutline
    },
    [DEALER_SERVICES_TYPES.INSURANCE_WITHOUT_EXCESS]: {
      [SERVICE_STATE.INCLUDED]: CarExtendedWarrantyOutline,
      [SERVICE_STATE.NOT_INCLUDED]: CarExtendedWarrantyOutline
    },
    [DEALER_SERVICES_TYPES.INSURANCE]: {
      [SERVICE_STATE.INCLUDED]: Calculator,
      [SERVICE_STATE.NOT_INCLUDED]: Calculator
    },
    [DEALER_SERVICES_TYPES.MAINTENANCE]: {
      [SERVICE_STATE.INCLUDED]: CarMechanicOutline,
      [SERVICE_STATE.NOT_INCLUDED]: CarMechanicCrossed
    },
    [DEALER_SERVICES_TYPES.MONTHLY_SUBSCRIPTION]: {
      [SERVICE_STATE.INCLUDED]: CalendarDaysOutline,
      [SERVICE_STATE.NOT_INCLUDED]: CalendarDaysOutline
    },
    [DEALER_SERVICES_TYPES.MULTIPLE_DRIVERS]: {
      [SERVICE_STATE.INCLUDED]: UsersOutline,
      [SERVICE_STATE.NOT_INCLUDED]: UsersCrossed
    },
    [DEALER_SERVICES_TYPES.NO_COMMITMENT]: {
      [SERVICE_STATE.INCLUDED]: CalendarCloseOutline,
      [SERVICE_STATE.NOT_INCLUDED]: CalendarCloseOutline
    },
    [DEALER_SERVICES_TYPES.NO_ENTRY_FEE]: {
      [SERVICE_STATE.INCLUDED]: NoEntryFee,
      [SERVICE_STATE.NOT_INCLUDED]: NoEntryFeeCrossed
    },
    [DEALER_SERVICES_TYPES.ONLINE_SHOPPING]: {
      [SERVICE_STATE.INCLUDED]: Buy,
      [SERVICE_STATE.NOT_INCLUDED]: Buy
    },
    [DEALER_SERVICES_TYPES.ONLINE]: {
      [SERVICE_STATE.INCLUDED]: Online,
      [SERVICE_STATE.NOT_INCLUDED]: Online
    },
    [DEALER_SERVICES_TYPES.PARKING]: {
      [SERVICE_STATE.INCLUDED]: Parking,
      [SERVICE_STATE.NOT_INCLUDED]: Parking
    },
    [DEALER_SERVICES_TYPES.PICKUP_DELIVERY]: {
      [SERVICE_STATE.INCLUDED]: CarDeliveryCarOutline,
      [SERVICE_STATE.NOT_INCLUDED]: CarDeliveryCarOutline
    },
    [DEALER_SERVICES_TYPES.PICKUP]: {
      [SERVICE_STATE.INCLUDED]: Customer,
      [SERVICE_STATE.NOT_INCLUDED]: Customer
    },
    [DEALER_SERVICES_TYPES.PROFESSIONAL_ADVICE]: {
      [SERVICE_STATE.INCLUDED]: ShieldUserOutline,
      [SERVICE_STATE.NOT_INCLUDED]: ShieldUserCrossed
    },
    [DEALER_SERVICES_TYPES.PURCHASE_OPTION]: {
      [SERVICE_STATE.INCLUDED]: ShoppingCartOutline,
      [SERVICE_STATE.NOT_INCLUDED]: ShoppingCartCrossed
    },
    [DEALER_SERVICES_TYPES.RENTING]: {
      [SERVICE_STATE.INCLUDED]: Renting,
      [SERVICE_STATE.NOT_INCLUDED]: Renting
    },
    [DEALER_SERVICES_TYPES.REPLACEMENT_VEHICLE]: {
      [SERVICE_STATE.INCLUDED]: CarSubstituteAlt,
      [SERVICE_STATE.NOT_INCLUDED]: CarSubstituteAltCrossed
    },
    [DEALER_SERVICES_TYPES.REPLACEMENT]: {
      [SERVICE_STATE.INCLUDED]: SubstitutionCar,
      [SERVICE_STATE.NOT_INCLUDED]: SubstitutionCarCrossed
    },
    [DEALER_SERVICES_TYPES.ROAD_ASSISTANCE]: {
      [SERVICE_STATE.INCLUDED]: TowTruckOutline,
      [SERVICE_STATE.NOT_INCLUDED]: TowTruckCrossed
    },
    [DEALER_SERVICES_TYPES.TRIAL_PERIOD]: {
      [SERVICE_STATE.INCLUDED]: CarTractionOutline,
      [SERVICE_STATE.NOT_INCLUDED]: CarTractionCrossed
    },
    [DEALER_SERVICES_TYPES.TRIAL]: {
      [SERVICE_STATE.INCLUDED]: Test,
      [SERVICE_STATE.NOT_INCLUDED]: Test
    },
    [DEALER_SERVICES_TYPES.TYRES]: {
      [SERVICE_STATE.INCLUDED]: CarWheel,
      [SERVICE_STATE.NOT_INCLUDED]: CarWheelCrossed
    },
    [DEALER_SERVICES_TYPES.UNLIMITED_MILEAGE]: {
      [SERVICE_STATE.INCLUDED]: Infinite,
      [SERVICE_STATE.NOT_INCLUDED]: InfiniteCrossed
    },
    [DEALER_SERVICES_TYPES.VEHICLE_CHANGE]: {
      [SERVICE_STATE.INCLUDED]: SubstitutionCar,
      [SERVICE_STATE.NOT_INCLUDED]: SubstitutionCarCrossed
    },
    [DEALER_SERVICES_TYPES.VEHICLE_PRE_DELIVERY]: {
      [SERVICE_STATE.INCLUDED]: CalendarCarOutline,
      [SERVICE_STATE.NOT_INCLUDED]: CalendarCarCrossed
    },
    [DEALER_SERVICES_TYPES.WARRANTY_EXTENSION]: {
      [SERVICE_STATE.INCLUDED]: Warranty,
      [SERVICE_STATE.NOT_INCLUDED]: CarExtendedWarrantyCrossed
    }
  }

  return ({id, isIncluded}) => {
    /**
     * This field is not returned yet from backend. When specifically return false (not undefined),
     * that's when we can actually say that the service is not included.
     */
    const isServiceNotIncluded = isIncluded === false
    const state = isServiceNotIncluded ? SERVICE_STATE.NOT_INCLUDED : SERVICE_STATE.INCLUDED
    return serviceIconMapper[id] ? serviceIconMapper[id][state] || Extras : Extras
  }
}

export const TYPES = {
  BRIEF: 'brief',
  COMPACT: 'compact',
  EXTENDED: 'extended'
}
